import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { PLACEMENTS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/placements/$id")({
  component: () => <DeptContentForm cfg={PLACEMENTS} id={Route.useParams().id} />,
});
